import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import Triggerable, { TriggerableDto } from "./Triggerable"
import { CommandType, TriggerableType, TriggerType } from "./triggerableTypes"

class TriggerableService {
    private static httpClient = new HttpClient<Triggerable, TriggerableDto>(Triggerable)

    static async getAll(triggerableType: TriggerableType): Promise<Triggerable[] | HttpError> {
        const res = await this.httpClient.get("/triggerables/" + triggerableType)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Triggerable[])
    }

    static async get(triggerableType: TriggerableType): Promise<Triggerable | HttpError | null> {
        const res = await this.httpClient.get("/triggerables/" + triggerableType)
        if (isError(res)) {
            return res as HttpError
        }
        const triggerables = res as Triggerable[]
        if (triggerables.length > 0) {
            return triggerables[0]
        }
        return null
    }

    static async create(triggerableType: TriggerableType,
        triggerKey: TriggerType,
        commandKey: CommandType,
        commandConfig: object
    ) {
        return this.httpClient.post("/triggerables", {
            "triggerableType": triggerableType,
            "triggerKey": triggerKey,
            "commandKey": commandKey,
            "config": commandConfig,
        })
    }

    static async update(triggerableId, isEnabled: null | boolean, commandConfig: null | object) {
        const payload = {}
        if (isEnabled != null) {
            payload["isEnabled"] = isEnabled
        }
        if (commandConfig != null) {
            payload["commandConfig"] = commandConfig
        }
        return this.httpClient.patch(`/triggerables/${triggerableId}`, payload)
    }

    static async toggle(triggerableId: string, isEnabled: boolean) {
        return this.update(triggerableId, isEnabled, null)
    }
}

export default TriggerableService


// WEBPACK FOOTER //
// ./src/state/triggerable/TriggerableService.ts